module.exports = __webpack_public_path__ + "assets/img/icon-6.f972b736.png";